var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25.02924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    * {\n      stroke-width: 0px;\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.44737,12.5l7.76316-7.76316c1.05263-1.05263,1.05263-2.89474,0-3.94737s-2.89474-1.05263-3.94737,0l-7.76316,7.76316L4.73684.78947C3.68421-.26316,1.8421-.26316.78947.78947S-.26316,3.68421.78947,4.73684l7.76316,7.76316L.78947,20.26316c-1.05263,1.05263-1.05263,2.89474,0,3.94737s1.31579.78947,1.97368.78947,1.44737-.26316,1.97368-.78947l7.76316-7.76316,7.76316,7.76316c.52632.52632,1.31579.78947,1.97368.78947s1.44737-.26316,1.97368-.78947c1.05263-1.05263,1.05263-2.89474,0-3.94737,0,0-7.76316-7.76316-7.76316-7.76316Z",
    fill: "#82368c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/CancelIcon.b99f059b5ae544441a909fd57a247ff5.svg";
export { ForwardRef as ReactComponent };